import React, {useLayoutEffect, useState} from 'react';
import {Route, Switch, useLocation} from 'react-router-dom';
import ShowLoading from './Components/loading/ShowLoading';
import { IconButton, Icons } from '@curves/ui-base';
import { PrivateRoute } from '@Components/';

import { SnackbarProvider, closeSnackbar } from 'notistack';
import {LOGIN_ROOT_ROUTER} from '@Router/routerPath';
import AppVersion from "./AppVersion";
import LoginPage from '@Local/Login/';
import Home from '@Local/Home/';
import '@Scss/site.scss';
const App = React.forwardRef((props, ref) => {
    const [isRoute, setRoute] = useState(false);
    const {pathname: rootPath = ''} = useLocation();
    // notistack v3 的關閉方法改由模組層 closeSnackbar 提供（不再掛在 Provider ref 上）
    const onClickDismiss = (snackbarId) => () => {
        closeSnackbar(snackbarId);
    };
    useLayoutEffect(
        () => {
            const splitPathname = rootPath.split('/');
            if (splitPathname.length > 1 && splitPathname[1] === 'login') setRoute(true);
        },
        // eslint-disable-next-line
        [rootPath]
    );
    return (
        <React.Fragment>
            <SnackbarProvider
                className="snacker-massage"
                maxSnack={3}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                action={(snackbarId) => (
                    <IconButton onClick={onClickDismiss(snackbarId)}>
                        <Icons.Close htmlColor="#fff"/>
                    </IconButton>
                )}
            >
                <AppVersion />
                <Switch>
                    {isRoute && <Route exact path={LOGIN_ROOT_ROUTER} component={LoginPage}/>}
                    <PrivateRoute as={Home}/>
                </Switch>
            </SnackbarProvider>
            <ShowLoading/>
        </React.Fragment>
    );
});
export default App;
